// removed by extract-text-webpack-plugin
module.exports = {"tagsCont":"Tag__tagsCont","tagsButton":"Tag__tagsButton","tagsButtonOutline":"Tag__tagsButtonOutline","tagsButtonSelected":"Tag__tagsButtonSelected","tagsButtonUnSelected":"Tag__tagsButtonUnSelected","tagsButtonDisabled":"Tag__tagsButtonDisabled","tagsButtonRemovable":"Tag__tagsButtonRemovable","tagsButtonRemoved":"Tag__tagsButtonRemoved"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tags/components/Tag/Tag.scss
// module id = 1789
// module chunks = 8